// Gitコマンドのオプション情報
export const gitCommandOptions = {
  init: {
    defaultBehavior: "カレントディレクトリに.gitディレクトリを作成してGitリポジトリを初期化。デフォルトブランチ名はmasterまたはmain。",
    options: [
      { flag: "--bare", origin: "bare（裸）", role: "作業ディレクトリなしのリポジトリ作成。サーバー用。" },
      { flag: "--initial-branch", origin: "initial branch（初期ブランチ）", role: "デフォルトブランチ名を指定。mainなど。" }
    ],
    combos: [
      { pattern: "git init", desc: "カレントディレクトリをGitリポジトリ化。プロジェクト開始の第一歩。" },
      { pattern: "git init --initial-branch=main", desc: "mainブランチで初期化。現代的な命名規則。" }
    ]
  },

  clone: {
    defaultBehavior: "リモートリポジトリの全履歴と全ブランチをローカルにコピー。完全なクローンを作成。",
    options: [
      { flag: "--depth", origin: "depth（深さ）", role: "履歴の深さを制限。浅いクローンで高速化。" },
      { flag: "--branch", origin: "branch（ブランチ）", role: "特定ブランチのみクローン。" },
      { flag: "--single-branch", origin: "single branch（単一ブランチ）", role: "指定ブランチのみ取得。容量節約。" }
    ],
    combos: [
      { pattern: "git clone https://github.com/user/repo.git", desc: "リポジトリをクローン。開発開始の定番。" },
      { pattern: "git clone --depth 1 https://github.com/user/repo.git", desc: "最新コミットのみ取得。CI/CDで高速化。" },
      { pattern: "git clone --branch develop --single-branch repo.git", desc: "developブランチのみクローン。" }
    ]
  },

  status: {
    defaultBehavior: "現在のブランチ、ステージング状態、作業ツリーの変更を詳細に表示。",
    options: [
      { flag: "-s", origin: "short（短縮）", role: "簡潔な形式で表示。スクリプト解析に便利。" },
      { flag: "-b", origin: "branch（ブランチ）", role: "ブランチ情報も表示。" }
    ],
    combos: [
      { pattern: "git status", desc: "作業ツリーの状態確認。Gitの基本コマンド。" },
      { pattern: "git status -sb", desc: "簡潔＋ブランチ情報。素早い状態把握。" }
    ]
  },

  add: {
    defaultBehavior: "指定したファイルをステージングエリアに追加。新規ファイルや変更されたファイルをコミット対象にする。",
    options: [
      { flag: "-A", origin: "all（すべて）", role: "全変更をステージング。削除も含む。" },
      { flag: "-p", origin: "patch（パッチ）", role: "対話的に変更を選択。部分コミットに。" },
      { flag: "-u", origin: "update（更新）", role: "追跡中ファイルの変更のみステージング。" }
    ],
    combos: [
      { pattern: "git add .", desc: "カレントディレクトリ配下を全てステージング。" },
      { pattern: "git add -A", desc: "全変更をステージング。削除も含めて一括追加。" },
      { pattern: "git add -p", desc: "対話的にステージング。変更を精査しながら追加。" }
    ]
  },

  commit: {
    defaultBehavior: "ステージング済みの変更をコミット。エディタが開いてメッセージ入力を要求。",
    options: [
      { flag: "-m", origin: "message（メッセージ）", role: "コミットメッセージを指定。エディタを開かない。" },
      { flag: "-a", origin: "all（すべて）", role: "追跡中ファイルを自動ステージング。add省略。" },
      { flag: "--amend", origin: "amend（修正）", role: "直前のコミットを修正。メッセージやファイル追加。" },
      { flag: "--no-verify", origin: "no verify（検証なし）", role: "pre-commitフックをスキップ。緊急時用。" }
    ],
    combos: [
      { pattern: "git commit -m 'feat: add login feature'", desc: "メッセージ付きコミット。開発の基本フロー。" },
      { pattern: "git commit -am 'fix: resolve bug'", desc: "add＋commitを一発実行。時短の定番。" },
      { pattern: "git commit --amend --no-edit", desc: "直前コミットにファイル追加。メッセージ変更なし。" }
    ]
  },

  log: {
    defaultBehavior: "コミット履歴を詳細形式で新しい順に表示。作者、日時、メッセージを含む。",
    options: [
      { flag: "--oneline", origin: "one line（1行）", role: "1コミット1行で表示。見やすい履歴。" },
      { flag: "--graph", origin: "graph（グラフ）", role: "ブランチ構造を視覚化。マージ確認に。" },
      { flag: "--all", origin: "all（すべて）", role: "全ブランチの履歴を表示。" },
      { flag: "-n", origin: "number（数）", role: "表示件数を制限。最新N件のみ。" },
      { flag: "--author", origin: "author（作者）", role: "特定作者のコミットのみ表示。" }
    ],
    combos: [
      { pattern: "git log --oneline --graph --all", desc: "全ブランチの履歴をグラフ表示。構造把握の鉄板。" },
      { pattern: "git log -10 --oneline", desc: "最新10件を簡潔表示。直近履歴の確認に。" },
      { pattern: "git log --author='John' --oneline", desc: "特定作者のコミット履歴。担当調査に。" }
    ]
  },

  diff: {
    defaultBehavior: "作業ツリーとインデックスの差分（未ステージ変更）を表示。",
    options: [
      { flag: "--staged", origin: "staged（ステージ済み）", role: "ステージング済み変更を表示。コミット前確認。" },
      { flag: "--cached", origin: "cached（キャッシュ済み）", role: "--stagedと同義。古い慣習名。" },
      { flag: "--name-only", origin: "name only（名前のみ）", role: "変更ファイル名のみ表示。概要把握に。" },
      { flag: "--stat", origin: "statistics（統計）", role: "変更統計を表示。追加/削除行数。" }
    ],
    combos: [
      { pattern: "git diff", desc: "作業ツリーの未ステージ変更を表示。修正内容確認。" },
      { pattern: "git diff --staged", desc: "ステージ済み変更を表示。コミット前の最終確認。" },
      { pattern: "git diff HEAD~1 HEAD", desc: "直前コミットとの差分表示。変更レビューに。" }
    ]
  },

  branch: {
    defaultBehavior: "ローカルブランチの一覧を表示。現在のブランチは*印で強調。",
    options: [
      { flag: "-a", origin: "all（すべて）", role: "ローカル＋リモートブランチを全表示。" },
      { flag: "-d", origin: "delete（削除）", role: "ブランチを削除。マージ済みのみ。" },
      { flag: "-D", origin: "force Delete（強制削除）", role: "未マージでも強制削除。注意して使用。" },
      { flag: "-m", origin: "move（移動）", role: "ブランチ名を変更。リネームに。" }
    ],
    combos: [
      { pattern: "git branch", desc: "ローカルブランチ一覧表示。現在ブランチ確認。" },
      { pattern: "git branch -a", desc: "全ブランチ表示。リモートブランチも含む。" },
      { pattern: "git branch -d feature-old", desc: "マージ済みブランチを削除。クリーンアップ。" }
    ]
  },

  checkout: {
    defaultBehavior: "指定ブランチまたはコミットに作業ツリーを切り替える。",
    options: [
      { flag: "-b", origin: "branch（ブランチ）", role: "新ブランチを作成して切替。" },
      { flag: "-", origin: "previous（前）", role: "直前のブランチに戻る。行き来に便利。" }
    ],
    combos: [
      { pattern: "git checkout -b feature/new-feature", desc: "新ブランチ作成＋切替。開発開始の定番。" },
      { pattern: "git checkout main", desc: "mainブランチに切替。ブランチ移動の基本。" },
      { pattern: "git checkout -", desc: "直前ブランチに戻る。行き来がスムーズ。" }
    ]
  },

  merge: {
    defaultBehavior: "指定ブランチを現在ブランチにマージ。可能ならfast-forward。",
    options: [
      { flag: "--no-ff", origin: "no fast-forward（早送りなし）", role: "必ずマージコミットを作成。履歴を明確化。" },
      { flag: "--squash", origin: "squash（押しつぶす）", role: "複数コミットを1つにまとめる。履歴整理。" },
      { flag: "--abort", origin: "abort（中止）", role: "コンフリクト発生時にマージを中止。" }
    ],
    combos: [
      { pattern: "git merge feature-branch", desc: "featureブランチをマージ。開発完了時の定番。" },
      { pattern: "git merge --no-ff develop", desc: "マージコミットを明示的に作成。履歴を残す。" },
      { pattern: "git merge --abort", desc: "コンフリクト解決を諦めてマージ中止。" }
    ]
  },

  rebase: {
    defaultBehavior: "現在ブランチのコミットを指定ブランチの最新に基づいて再適用。履歴を線形化。",
    options: [
      { flag: "-i", origin: "interactive（対話的）", role: "対話的リベース。コミット履歴を編集。" },
      { flag: "--onto", origin: "onto（上に）", role: "リベース先を明示的に指定。" },
      { flag: "--continue", origin: "continue（継続）", role: "コンフリクト解決後に再開。" },
      { flag: "--abort", origin: "abort（中止）", role: "リベースを中止。元の状態に戻す。" }
    ],
    combos: [
      { pattern: "git rebase main", desc: "mainブランチの最新に基づいて履歴を書き換え。" },
      { pattern: "git rebase -i HEAD~3", desc: "直近3コミットを対話的に編集。履歴整理の鉄板。" },
      { pattern: "git rebase --continue", desc: "コンフリクト解決後にリベース再開。" }
    ]
  },

  fetch: {
    defaultBehavior: "デフォルトリモート（origin）の全ブランチ情報を取得。ローカルは変更しない。",
    options: [
      { flag: "--all", origin: "all（すべて）", role: "全リモートから取得。複数リモート管理時に。" },
      { flag: "--prune", origin: "prune（刈り込む）", role: "削除されたリモートブランチを反映。クリーンアップ。" },
      { flag: "-p", origin: "prune（刈り込む）", role: "--pruneの短縮形。" }
    ],
    combos: [
      { pattern: "git fetch origin", desc: "リモートの最新状態を取得。マージ前の確認に。" },
      { pattern: "git fetch --all --prune", desc: "全リモートから取得＋古いブランチ削除。定期メンテナンス。" }
    ]
  },

  pull: {
    defaultBehavior: "デフォルトリモートから現在ブランチをfetch＋merge。上流ブランチ設定が必要。",
    options: [
      { flag: "--rebase", origin: "rebase（リベース）", role: "マージの代わりにリベース。履歴を一直線に。" },
      { flag: "--ff-only", origin: "fast-forward only（早送りのみ）", role: "早送りマージのみ許可。安全な更新。" },
      { flag: "--no-commit", origin: "no commit（コミットなし）", role: "マージ後自動コミットしない。確認用。" }
    ],
    combos: [
      { pattern: "git pull origin main", desc: "リモートmainをfetch＋merge。最新化の基本。" },
      { pattern: "git pull --rebase origin develop", desc: "リベースしながら取得。綺麗な履歴維持。" },
      { pattern: "git pull --ff-only", desc: "早送り可能な場合のみ更新。安全重視。" }
    ]
  },

  push: {
    defaultBehavior: "現在ブランチをデフォルトリモートの同名ブランチにプッシュ。上流設定が必要。",
    options: [
      { flag: "-u", origin: "upstream（上流）", role: "上流ブランチを設定。次回以降pushが楽に。" },
      { flag: "--force", origin: "force（強制）", role: "強制プッシュ。リベース後など。危険。" },
      { flag: "--force-with-lease", origin: "force with lease（リース付き強制）", role: "他人の変更を上書きしない安全な強制プッシュ。" },
      { flag: "--delete", origin: "delete（削除）", role: "リモートブランチを削除。" }
    ],
    combos: [
      { pattern: "git push origin main", desc: "mainブランチをリモートにプッシュ。公開の基本。" },
      { pattern: "git push -u origin feature-branch", desc: "新ブランチを初回プッシュ＋上流設定。" },
      { pattern: "git push --force-with-lease", desc: "安全な強制プッシュ。リベース後に使用。" },
      { pattern: "git push --delete origin old-branch", desc: "リモートブランチを削除。クリーンアップ。" }
    ]
  },

  remote: {
    defaultBehavior: "設定済みリモートの名前一覧を表示。URLは表示されない。",
    options: [
      { flag: "-v", origin: "verbose（詳細）", role: "リモートURLも表示。設定確認に。" },
      { flag: "add", origin: "add（追加）", role: "新しいリモートを追加。" },
      { flag: "remove", origin: "remove（削除）", role: "リモートを削除。" },
      { flag: "rename", origin: "rename（名前変更）", role: "リモート名を変更。" }
    ],
    combos: [
      { pattern: "git remote -v", desc: "リモートURL一覧表示。接続先確認。" },
      { pattern: "git remote add upstream https://github.com/original/repo.git", desc: "フォーク元を追加。OSS貢献の準備。" },
      { pattern: "git remote remove origin", desc: "originリモートを削除。再設定時に。" }
    ]
  },

  stash: {
    defaultBehavior: "追跡済みファイルの未コミット変更を一時退避。作業ツリーをクリーンに。",
    options: [
      { flag: "push", origin: "push（プッシュ）", role: "変更を退避。デフォルト動作。" },
      { flag: "pop", origin: "pop（取り出す）", role: "退避した変更を復元＋削除。" },
      { flag: "list", origin: "list（一覧）", role: "退避した変更の一覧表示。" },
      { flag: "apply", origin: "apply（適用）", role: "退避した変更を復元（削除しない）。" },
      { flag: "drop", origin: "drop（破棄）", role: "退避した変更を削除。" }
    ],
    combos: [
      { pattern: "git stash", desc: "作業中の変更を一時退避。緊急ブランチ切替時に。" },
      { pattern: "git stash pop", desc: "退避した変更を復元。作業再開。" },
      { pattern: "git stash list", desc: "退避した変更の履歴確認。" },
      { pattern: "git stash push -m 'work in progress'", desc: "メッセージ付きで退避。管理しやすい。" }
    ]
  },

  tag: {
    defaultBehavior: "ローカルの全タグ一覧を表示。アルファベット順。",
    options: [
      { flag: "-a", origin: "annotated（注釈付き）", role: "注釈付きタグを作成。リリースに推奨。" },
      { flag: "-m", origin: "message（メッセージ）", role: "タグメッセージを指定。" },
      { flag: "-d", origin: "delete（削除）", role: "タグを削除。" },
      { flag: "-l", origin: "list（一覧）", role: "タグ一覧を表示。パターン指定可能。" }
    ],
    combos: [
      { pattern: "git tag -a v1.0.0 -m 'Release version 1.0.0'", desc: "注釈付きタグ作成。リリースの基本。" },
      { pattern: "git push origin v1.0.0", desc: "タグをリモートにプッシュ。リリース公開。" },
      { pattern: "git tag -l 'v1.*'", desc: "バージョン1系のタグ一覧表示。" }
    ]
  },

  reset: {
    defaultBehavior: "HEADを指定コミットに移動し、インデックスをリセット（--mixed）。作業ツリーは保持。",
    options: [
      { flag: "--soft", origin: "soft（ソフト）", role: "コミットのみ取消。ステージング領域は保持。" },
      { flag: "--mixed", origin: "mixed（ミックス）", role: "コミット＋ステージング取消。作業ツリーは保持。デフォルト。" },
      { flag: "--hard", origin: "hard（ハード）", role: "コミット＋ステージング＋作業ツリー全取消。完全リセット。危険。" }
    ],
    combos: [
      { pattern: "git reset HEAD~1", desc: "直前コミットを取消。修正してやり直し。" },
      { pattern: "git reset --soft HEAD~1", desc: "コミットのみ取消。ステージング状態に戻す。" },
      { pattern: "git reset --hard HEAD", desc: "作業ツリーを最終コミット状態にリセット。全変更破棄。" }
    ]
  },

  revert: {
    defaultBehavior: "指定コミットの変更を打ち消す新しいコミットを自動作成。履歴は保持。",
    options: [
      { flag: "-n", origin: "no-commit（コミットなし）", role: "自動コミットせず変更のみ適用。複数revert時に。" },
      { flag: "--no-edit", origin: "no edit（編集なし）", role: "デフォルトメッセージでコミット。素早い取消。" }
    ],
    combos: [
      { pattern: "git revert HEAD", desc: "直前コミットを打ち消す新規コミット作成。安全な取消。" },
      { pattern: "git revert abc123", desc: "特定コミットを打ち消す。履歴は残る。" },
      { pattern: "git revert -n HEAD~3..HEAD", desc: "複数コミットを一括revert。まとめて取消。" }
    ]
  },

  restore: {
    defaultBehavior: "指定ファイルの作業ツリーを最終コミット状態に復元。変更を破棄。",
    options: [
      { flag: "--staged", origin: "staged（ステージ済み）", role: "ステージングを取消。addの取消に。" },
      { flag: "--source", origin: "source（ソース）", role: "復元元のコミットを指定。" },
      { flag: "--worktree", origin: "worktree（作業ツリー）", role: "作業ツリーのファイルを復元。" }
    ],
    combos: [
      { pattern: "git restore file.txt", desc: "作業ツリーのファイルを最終コミット状態に復元。" },
      { pattern: "git restore --staged file.txt", desc: "ステージング解除。git add取消。" },
      { pattern: "git restore --source=HEAD~1 file.txt", desc: "1つ前のコミットからファイル復元。" }
    ]
  },

  "cherry-pick": {
    defaultBehavior: "指定コミットの変更を現在ブランチに新規コミットとして適用。",
    options: [
      { flag: "-n", origin: "no-commit（コミットなし）", role: "自動コミットせず変更のみ適用。" },
      { flag: "-x", origin: "append source（ソース追記）", role: "元コミットのハッシュをメッセージに追記。トレーサビリティ向上。" },
      { flag: "--continue", origin: "continue（継続）", role: "コンフリクト解決後に再開。" }
    ],
    combos: [
      { pattern: "git cherry-pick abc123", desc: "特定コミットを現在ブランチに適用。バグフィックス移植に。" },
      { pattern: "git cherry-pick -n abc123 def456", desc: "複数コミットを適用。まとめて移植。" }
    ]
  },

  reflog: {
    defaultBehavior: "HEADの参照履歴を新しい順に表示。削除したコミットも含む完全な操作記録。",
    options: [
      { flag: "-n", origin: "number（数）", role: "表示件数を制限。" }
    ],
    combos: [
      { pattern: "git reflog", desc: "HEADの移動履歴表示。間違った操作の復旧に。" },
      { pattern: "git reflog -10", desc: "直近10件の操作履歴表示。最近の操作確認。" },
      { pattern: "git reset --hard HEAD@{3}", desc: "reflogから3つ前の状態に復旧。タイムマシン。" }
    ]
  },

  blame: {
    defaultBehavior: "ファイルの各行について、最終変更者、コミットハッシュ、日時を注釈表示。",
    options: [
      { flag: "-L", origin: "line range（行範囲）", role: "行範囲を指定。特定部分のみ調査。" },
      { flag: "-w", origin: "ignore whitespace（空白無視）", role: "空白変更を無視。本質的な変更を追跡。" }
    ],
    combos: [
      { pattern: "git blame file.txt", desc: "各行の最終変更者とコミットを表示。責任追跡。" },
      { pattern: "git blame -L 10,20 file.txt", desc: "10〜20行目の変更履歴を表示。部分調査。" }
    ]
  },

  show: {
    defaultBehavior: "最新コミット（HEAD）の詳細情報と差分を表示。",
    options: [
      { flag: "--stat", origin: "statistics（統計）", role: "変更統計を表示。" },
      { flag: "--name-only", origin: "name only（名前のみ）", role: "変更ファイル名のみ表示。" }
    ],
    combos: [
      { pattern: "git show HEAD", desc: "最新コミットの詳細表示。差分込み。" },
      { pattern: "git show abc123", desc: "特定コミットの内容表示。レビューに。" },
      { pattern: "git show --stat HEAD", desc: "最新コミットの変更統計表示。概要把握。" }
    ]
  },

  clean: {
    defaultBehavior: "未追跡ファイルの削除予定リストを表示。実際には削除しない（-nが暗黙的）。",
    options: [
      { flag: "-n", origin: "dry-run（予行演習）", role: "削除予定ファイルを表示。実際は削除しない。" },
      { flag: "-f", origin: "force（強制）", role: "未追跡ファイルを削除。実行には必須。" },
      { flag: "-d", origin: "directory（ディレクトリ）", role: "未追跡ディレクトリも削除。" },
      { flag: "-x", origin: "ignored files（無視ファイル）", role: ".gitignoreファイルも削除。完全クリーンアップ。" }
    ],
    combos: [
      { pattern: "git clean -n", desc: "削除予定ファイル確認。安全確認。" },
      { pattern: "git clean -fd", desc: "未追跡ファイル＋ディレクトリ削除。クリーンな状態に。" },
      { pattern: "git clean -fdx", desc: ".gitignore含めて全削除。ビルド成果物も消去。" }
    ]
  },

  config: {
    defaultBehavior: "設定の読み書きを行うヘルプ表示。設定キーと値の指定が必要。",
    options: [
      { flag: "--global", origin: "global（グローバル）", role: "ユーザー全体の設定。~/.gitconfig に保存。" },
      { flag: "--local", origin: "local（ローカル）", role: "リポジトリ固有の設定。デフォルト。" },
      { flag: "--list", origin: "list（一覧）", role: "設定一覧を表示。" }
    ],
    combos: [
      { pattern: "git config --global user.name 'Your Name'", desc: "ユーザー名を設定。初回設定の必須項目。" },
      { pattern: "git config --global user.email 'you@example.com'", desc: "メールアドレス設定。コミット情報に使用。" },
      { pattern: "git config --list", desc: "全設定を表示。環境確認に。" }
    ]
  },

  switch: {
    defaultBehavior: "指定ブランチに作業ツリーを切り替える。checkoutのブランチ切替専用版。",
    options: [
      { flag: "-c", origin: "create（作成）", role: "新ブランチを作成して切替。checkout -bの後継。" },
      { flag: "-d", origin: "detach（デタッチ）", role: "特定コミットにデタッチドHEADで移動。" }
    ],
    combos: [
      { pattern: "git switch main", desc: "mainブランチに切替。checkoutの現代版。" },
      { pattern: "git switch -c feature/new-ui", desc: "新ブランチ作成＋切替。開発開始。" },
      { pattern: "git switch -", desc: "直前ブランチに戻る。行き来に便利。" }
    ]
  }
};

export const getGitOptions = (commandName) => {
  return gitCommandOptions[commandName] || null;
};
